/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/paging/paging-object',['require','backbone','jsonEditor'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var Backbone = require('backbone');

  require('jsonEditor');

  /*****************************************************************************************************************///}

  var PagingObject = Backbone.Model.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    radio: null,

    defaults: function()
    {
      return {
        complete         : false,
        locked           : true,
        required         : true,
        requirements     : [],
        autonomous       : false,
        status           : 'incomplete',
        storage          : { },
        seen             : false,
        isComplete       : false,
        maxPoints        : 0,
        earnedPoints     : 0,
        inOverlay        : false,
        type             : 'page'
      };
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      this.radio = Backbone.Wreqr.radio.channel('global').vent;
      ////console.log('new page obj', options, options.requirements);
      this.on('change:complete', this.onComplete, this);
    },

    setActive: function(index)
    {
      ////console.log('PagingObject::setActive');
      // if (!this.get('complete'))
        //this.set('status', 'in-progress');

      if (this.collection && this.collection.parent)
      {
        var myIndex = this.collection.indexOf(this);
        this.collection.parent.setActive(myIndex);
      }
    },

    setRequirements: function()
    {
      // do nothing
    },

    checkLocks: function()
    {
      this.radio.trigger('paging:checklocks', this);
    },

    unlock: function()
    {
      //console.log('Unlocking: ' + this.get('id'));
      this.set('locked', false, { silent: true });
    },

    lock: function()
    {
      //console.log('Locking: ' + this.get('id'));
      this.set('locked', true, { silent: true });
    },

    first: function()
    {
      return this;
    },

    current: function()
    {
      return this;
    },

    load: function()
    {

    },

    serialize: function()
    {
      var data = { };

      return data;
    },

    deserialize: function(data)
    {
      for (var prop in data)
      {
        //console.log('prop', this, prop, data[prop]);
        this.set(prop, data[prop], { silent: true });
      }
    },

    find: function(id)
    {
      return (this.id === id) ? this : null;
    },

    onComplete: function()
    {
      this.radio.trigger('status:change');
    },

    getPages: function()
    {
      return this;
    },

    finish: function()
    {
      //console.log('PagingObject::finish', this);

      this.trigger('complete', this);

      this.set('complete', true);
      this.set('seen', true);
      this.set('status', 'complete');

      this.trigger('complete', this);

      if (this.collection)
        this.collection.trigger('change');
    }

  /*****************************************************************************************************************///}

  });

  return PagingObject;

});

